import React from "react"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import CustomerPortalSettingsPresenterTabContent from  "./CustomerPortalSettingsPresenterTabContent"
import Tabs from '../Tabs/Tabs'

export default class CustomerPortalSettingsPresenter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      active_tab: 'general',
      ...this.props
    }
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
  }


  render() {
    var self = this;

    return (
      <div className="customer-portal-settings-presenter">
        <Tabs tabs={this.Tabs()} />
        <div className="panel panel-form">
          <CustomerPortalSettingsPresenterTabContent {...this.state} />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  Tabs(){
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('history'),
          targetName: 'history',
          classes: this.state.active_tab === 'history' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        }
      ]
    );
  };


  onChangeActiveTab(activeTab) {
    // event.stopPropagation();
    // event.preventDefault();
    this.setState({
      active_tab: activeTab
    })
  }
};
